import {Component, OnInit, Input, ViewChild, Output, EventEmitter} from '@angular/core';
import {ModalComponent} from '@app/shared/components';
import * as FileSaver from 'file-saver';

@Component({
    selector: 'app-pdf-viewer',
    templateUrl: './pdf-viewer.component.html',
    styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent implements OnInit {
    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;
    @Input() fileName: string;
    @Output() closePdfViewer = new EventEmitter<any>();
    pdfLink: {};

    documentBlob: any;
    documentName: string;
    showPdfViewer = false;

    constructor() {
    }

    ngOnInit() {
    }

    open(fileUrl: string, fileName: string = null, body: any = null) {
        const fileExtension = this.getFileExtension(fileName);
        this.documentName = fileName;

        if (fileExtension === 'pdf') {
            this.showPdfViewer = true;
            this.pdfLink = {
                url: fileUrl,
                httpHeaders: {Authorization: 'Bearer ' + localStorage.getItem('user_token')},
                withCredentials: true,
            }
        } else {
            this.showPdfViewer = false;
            this.documentBlob = body;
        }

        this.modal.open();
    }

    close() {
        this.modal.close();
        this.closePdfViewer.emit();
    }

    downloadFile() {
        if (this.documentBlob) {
            FileSaver.saveAs(this.documentBlob, this.name);
        }
    }

    hasDownload() {
        return this.documentBlob;
    }

    get name() {
        return this.documentName ?? 'Document'
    }

    private getFileExtension(url: string): string {
        return url.split('.').pop()?.toLowerCase() || '';
    }
}
